import React, { FC, useState, useRef } from 'react';
import DropdownItem from 'ui/MultipleSelect/DropdownItem';
// import useOnClickOutside from '@Utils/hooks/useOnClickOutside';

interface IMultipleSelect {
  id: string;
  name: string;
  label: string;
  placeholder: string;
  value?: string[];
  error?: string;
  dropdownItems: string[];
  customStyles?: any;
  filterFormData: any;
  setFilterFormData: (state: any) => void;
  setFilterFormErrors: (state: any) => void;
  isRequired?: boolean;
}

const MultipleSelect: FC<IMultipleSelect> = ({
  id,
  name,
  label,
  placeholder,
  value,
  error,
  dropdownItems,
  customStyles,
  filterFormData,
  setFilterFormData,
  setFilterFormErrors,
  isRequired,
}: IMultipleSelect) => {
  const [inputValue, setInputValue] = useState('');
  const [isDropdownOpened, setIsDropdownOpened] = useState<boolean>(false);

  const dropdownRef = useRef<HTMLUListElement>(null);

  const openDropdownHandler = () => {
    setIsDropdownOpened(!isDropdownOpened);
  };

  const dropdownElements = dropdownItems.map((item: string, index: number) => {
    return (
      <DropdownItem
        key={`${item}_${index}`}
        name={label.toLocaleLowerCase()}
        label={item}
        filterFormData={filterFormData}
        setFilterFormData={setFilterFormData}
        setFilterFormErrors={setFilterFormErrors}
      />
    );
  });

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  // useOnClickOutside(dropdownRef, () => setIsDropdownOpened(false));

  return (
    <div className="multiple-select" style={customStyles ? customStyles : {}} onClick={openDropdownHandler}>
      <label className="multiple-select__label" htmlFor={id}>
        <span className="multiple-select__label-text">
          {isRequired && '* '}
          {label}
        </span>

        <input
          className={`multiple-select__input ${error ? 'error' : ''}`}
          type="text"
          readOnly={true}
          id={id}
          name={name}
          // @ts-ignore
          placeholder={value?.length ? value : placeholder}
          value={inputValue ?? ''}
          onChange={onChangeHandler}
        />

        <img
          className={`multiple-select__input-icon ${isDropdownOpened ? 'is-opened' : ''}`}
          src="/images/pages/Resources/Blacklist/icon_arrow-down.svg"
          alt="dropdown-icon"
        />

        <ul className={`multiple-select__dropdown ${isDropdownOpened ? 'is-opened' : ''}`} ref={dropdownRef}>
          {dropdownElements}
        </ul>
      </label>
      {error ? <p className="multiple-select__error">{error}</p> : <></>}
    </div>
  );
};

export default React.memo(MultipleSelect);
